import { EndPointService } from 'src/services/api-handlers/axios';

const ROUTE = 'quizzes';

const list = (params: any) => EndPointService.get(`/${ROUTE}`, params);
const get = (id: string) => EndPointService.get(`/${ROUTE}/${id}`);

export default {
    list,
    get,
};
